import { CleaveOptions } from 'cleave.js/options';
import { Field } from 'formik';
import React, { Component } from 'react';
import { Nullable } from '../../Shared/Types';
import { AutoCompleteTypes, MaskedTextField } from '../MaskedTextField';
import { getErrorText } from './getErrorText';

type TextFieldProps = {
    name: string;
    testId: string;
    label?: Nullable<string>;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    helperText?: string;
    autoFocus?: boolean;
    multiline?: boolean;
    placeholder?: string;
    rowsMax?: number;
    maxLength?: number;
    warningText?: string;
    startAdornment?: React.ReactNode;
    autoCompleteType?: AutoCompleteTypes;
    formatOptions?: CleaveOptions;
    shrinkLabel?: boolean;
    hideWarningEmptyHelperText?: boolean;
    noWrapReadOnly?: boolean;
    filterFunction?(value: string): string;
    formatFunction?(value: string): string;
    unformatFunction?(value: string): string;
    onClear?(): void;
    onChange?(value: string, event?: React.ChangeEvent<HTMLInputElement>): void;
};

export class FormikTextField extends Component<TextFieldProps> {
    public render() {
        return <Field name={this.props.name}>{this.renderFormikTextField}</Field>;
    }

    private renderFormikTextField = ({ field, form }: any) => {
        const errorText = getErrorText(form, field.name);
        const onClear = () => {
            form.setFieldValue(field.name, '');
            form.setFieldTouched(field.name, true, false);

            if (this.props.onClear) this.props.onClear();
        };

        const onChange = (value: string, event?: React.ChangeEvent<HTMLInputElement>) => {
            form.setFieldValue(field.name, value);
            form.setFieldTouched(field.name, true, false);

            if (this.props.onChange) this.props.onChange(value, event);
        };

        return (
            <MaskedTextField
                {...this.props}
                value={field.value || ''}
                name={field.name}
                fullWidth
                onChange={onChange}
                onClear={onClear}
                errorText={errorText}
                shrinkLabel={this.props.shrinkLabel && !!field.value}
            />
        );
    };
}
